export default "__VITE_ASSET__c610a970__"